import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Flex } from "@opensea/ui-kit";
import { ArrowRightAlt } from "@opensea/ui-kit/icons";
import { TokenPrice } from "@/components/price/TokenPrice";
import { TokenSwapRouteFragment } from "./TokenSwapRoute.fragment";
export const TokenSwapRoute = t0 => {
  const $ = _c(10);
  const {
    activity: activityKey
  } = t0;
  let t1;
  if ($[0] !== activityKey) {
    t1 = readFragment(TokenSwapRouteFragment, activityKey);
    $[0] = activityKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activity = t1;
  let t2;
  if ($[2] !== activity.fromToken) {
    t2 = <TokenPrice currency="crypto" display="compact" price={activity.fromToken} />;
    $[2] = activity.fromToken;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowRightAlt size={20} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activity.toToken) {
    t4 = <TokenPrice currency="crypto" display="compact" price={activity.toToken} />;
    $[5] = activity.toToken;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Flex className="items-center gap-2">{t2}{t3}{t4}</Flex>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};